import { BaseModel } from "./base/base.model";
import { ConceptosPagaBolsaVacacionesEmpresa } from "./conceptosPagaBolsaVacacionesEmpresa.model";
import { ConveniosEmpresa } from "./conveniosEmpresa.model";
import { NotificacionesEmpresa } from "./notificacionesEmpresas.model";

export class ConfiguracionEmpresa extends BaseModel {
  IdCliente: string;
  CodigoEmpresa: number;
  Convenios: ConveniosEmpresa[];
  Notificaciones: NotificacionesEmpresa[];
}
